module.exports = __webpack_public_path__ + "static/media/icon_atm_sign.b3b6b68d.svg";